import React, {Component} from 'react';
import Header from "./Header";
import AppNavbar from "./Sidebar";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";
import axios from "axios";


export default class TerminalSurchargeSummary extends Component {


    constructor (props) {
        super(props)
        this.state = {
            loggedInUser:null,
            fromDate: '-1',
            toDate: '2024',
            terminalId: '-1',
            disabled : false,
            terminalDetails: [],
            userViewInfo: []
        };
        this.handleToUserId = this.handleToUserId.bind(this);
        this.handleFromDate = this.handleFromDate.bind(this);
        this.handleToTerminalId = this.handleToTerminalId.bind(this);
        this.handleToDate = this.handleToDate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {

                this.setState({ loggedInUser: response.data })
                console.log("=== LOG_1 === Inside componentDidMount %s with data ","Surcharge Summary Terminal",this.state.loggedInUser);
                //Get Terminal Ids




            }).finally(()=> {
            axios.get('getTerminalByUserId?id='+this.state.loggedInUser)
                .then(response => {
                    this.setState({ terminalDetails: response.data.response,loading: false })
                }).finally(()=> {
            })
                .catch(error => {
                    console.log("Exception Thrown::{ get Terminal details by ID}",error);
                });

            axios.get('getUserViewList?id='+this.state.loggedInUser)
                .then(response => {
                    this.setState({ userViewInfo: response.data.response,loading: false })
                }).finally(()=> {
            })
                .catch(error => {
                    console.log("Exception Thrown::{ get user details by ID}",error);
                });
        })
            .catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });


    }

    handleToUserId(event) {
        console.log("Changed Value for user-----",event.target.value)
        axios.get('getTerminalByUserId?id='+event.target.value)
            .then(response => {
                this.setState({ terminalDetails: response.data.response,loading: false })
            }).finally(()=> {
        })
            .catch(error => {
                console.log("Exception Thrown::{ get Terminal details by ID when used changes }",error);
            });
        this.setState({
            userId: event.target.value
        });
    }

    handleFromDate(event) {
        console.log("Changed Value for Date-----",event.target.value)
        this.setState({
            fromDate: event.target.value
        });
    }

    handleToTerminalId(event) {
        console.log("Changed Value for Terminal-----",event.target.value)
        this.setState({
            terminalId: event.target.value
        });
    }

    handleToDate(event) {
        console.log("Changed Value -----",event.target.value)
        this.setState({
            toDate: event.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        let userDetailID= '';
        console.log(this.state.fromDate,"FromDate ---- ----Todate ------terminalId",this.state.toDate,this.state.terminalId);
        if(this.state.fromDate === '-1'){
            alert(" Please provide valid  Month !!")
            return false;
        }
        if (this.state.disabled) {
            return;
        }
        if (this.state.userId === undefined || this.state.userId === null || this.state.userId  === '') {
            userDetailID = this.state.loggedInUser;
        }else{
            userDetailID = this.state.userId;
        }
        //this.setState({disabled: true});
        axios({
            url: 'downloadTerminalSurchargeSummaryReport?userid='+ userDetailID+"&pMonth="+this.state.fromDate+"&pYear="+this.state.toDate+"&terminalId="+this.state.terminalId, //your url
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'PartnerReportByTID.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.setState({disabled: false});
        });

        axios({
            url: 'downloadTerminalPayeeSummaryReport?userid='+ userDetailID+"&pMonth="+this.state.fromDate+"&pYear="+this.state.toDate+"&terminalId="+this.state.terminalId, //your url
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'PartnerReportByPayee.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.setState({disabled: false});
        });
    }

    render() {

        const alignBox = {
            display: "flex",
            justifyContent: "space-around"
        };

        const terminalList = this.state.terminalDetails.map((i) => {
            return <option value={i.terminalId}>{i.terminalId}</option>;
        });
        terminalList.unshift(<option value="-1" selected='selected'>Select All</option>)

        const userList = this.state.userViewInfo.map((i) => {
            return <option value={i.userId}>{i.userId}</option>;
        });
        userList.unshift(<option value={this.state.loggedInUser}>{this.state.loggedInUser}</option>)
        return (
            <body data-sidebar="colored">
            <div id="layout-wrapper">
                <Header/>
                <AppNavbar data={this.state}/>
            </div>
            <div className="main-content">
                <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
                <MetaTags>
                    <title>DataStream Version 2.0</title>
                    <meta name="description" content="Some description." />
                    <meta property="og:title" content="DataStream Version 2.0" />
                </MetaTags>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Report Management</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-9">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="tab-content p-3 text-muted">
                                            <div className="form-group">
                                                <form onSubmit={ this.handleSubmit }>
                                                    <div className="form-group" style={alignBox}>
                                                        <div>
                                                            <label className="control-label"><strong>Users: </strong></label>
                                                            <select name="userId" id="userId" className="custom-select" onChange={this.handleToUserId} >
                                                                {userList}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label><strong>Month: </strong></label>
                                                            <select id="fromDate" onChange={this.handleFromDate} className="form-control select2">
                                                                        <option value="-1" selected='selected'>Select All</option>
                                                                        <option value="1">January</option>
                                                                <option value='2'>February</option>
                                                                <option value='3'>March</option>
                                                                <option value='4'>April</option>
                                                                <option value='5'>May</option>
                                                                <option value='6'>June</option>
                                                                <option value='7'>July</option>
                                                                <option value='8'>August</option>
                                                                <option value='9'>September</option>
                                                                <option value='10'>October</option>
                                                                <option value='11'>November</option>
                                                                <option value='12'>December</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label><strong>Year:</strong> </label>
                                                            <select id="toDate" onChange={this.handleToDate} className="form-control select2">

                                                                <option value="2021">2021</option>
                                                                <option value='2022'>2022</option>
                                                                <option value="2023">2023</option>
                                                                <option value='2024' selected="selected">2024</option>
                                                                <option value='2025'>2025</option>
                                                                <option value="2026">2026</option>
                                                                <option value="2027">2027</option>
                                                                <option value="2028">2028</option>
                                                                <option value="2029">2029</option>
                                                                <option  value="2030">2030</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label><strong>Terminals:</strong> </label>
                                                            <select name="terminalId" id="terminalId" className="form-control select2" onChange={this.handleToTerminalId} >
                                                                {terminalList}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button className="btn btn-primary" onClick={this.handleClick} disabled={this.state.disabled} >Generate Report</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </body>
        );
    }
}